// extracted by mini-css-extract-plugin
export default {"container":"_782f5082","tileWidth":"_e0e51fd7","shopNowButton":"_f73ed741","shopNowDescription":"_ebd7a91"};